/* eslint-disable import/no-anonymous-default-export */
export default {
  "project.new": "Neues Projekt",
  "project.edit": "Projekt bearbeiten",
  "project.delete": "Projekt löschen",
  "project.add.title": "Erstellen Sie ein neues Projekt",
  "project.update.title": "Aktualisieren Sie das Projekt",
  "project.name": "Projektname",
  "project.description": "Projektbeschreibung",
  "project.details": "Details",
  "project.apply": "Anwenden",
  "project.name.message": "Bitte geben Sie den Projektnamen ein",
  "project.description.message": "Bitte geben Sie die Projektbeschreibung ein",
  "project.stage": "Status",
  "project.stage.message": "Bitte wählen Sie einen Status",
  "project.workNumber": "Projektcode",
  "project.workNumber.message": "Bitte geben Sie den Projektcode ein",
  "project.workNumber.exists":
    "Ein Projekt mit demselben Code existiert bereits. Möchten Sie es trotzdem registrieren?",
  "project.revision": "Akzeptierter Revisionsstil",
  "project.revision.styles": "Erlaubte Revisionsstile",
  "project.revision.message": "Wählen Sie einen Revisionsstil",
  "project.revision.numeric": "Numerisch (Bsp.: -R00; -R36; -R87)",
  "project.revision.doubleNumeric":
    "Doppelt Numerisch (Bsp.: -R00.00; -R00.01; -R01.00)",
  "project.revision.alphabetical": "Alphabetisch (Bsp.: -RA; -RY; -RAG)",
  "project.revision.alert":
    "Der Revisionsstil kann nach der Projekterstellung nicht geändert werden.",
  "project.link": "Link",
  "project.forum": "Forum",
  "project.company": "Unternehmen",
  "project.avatar": "Avatar",
  "project.form.data": "Projektdaten",
  "project.form.access": "Projektzugriffe",
  "project.company.message": "Bitte wählen Sie ein Unternehmen",
  "project.already.created":
    "Projekt bereits erstellt, bitte wählen Sie einen anderen Namen",

  "project.stage.IN PROGRESS": "In Bearbeitung",
  "project.stage.INACTIVE": "Inaktiv",
  "project.stage.DELIVERED": "Geliefert",
  "project.stage.CHANGING": "In Änderung",

  "project.stage.mode.message": "Wählen Sie einen Status",

  "project.emptyDataMessage.message": "Hallo, hier ist noch nichts.",
  "project.emptyDataMessage.instructions":
    "Sie können beginnen, indem Sie ein neues Projekt erstellen!",
  "project.emptyDataMessage.newProject": "+ Neues Projekt",
};
